import { render, staticRenderFns } from "./apiTestDoc.vue?vue&type=template&id=fd78e610&scoped=true&"
import script from "./apiTestDoc.vue?vue&type=script&lang=js&"
export * from "./apiTestDoc.vue?vue&type=script&lang=js&"
import style0 from "./apiTestDoc.vue?vue&type=style&index=0&id=fd78e610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd78e610",
  null
  
)

export default component.exports